import { render, staticRenderFns } from "./PageNester.vue?vue&type=template&id=2c6849ac&lang=pug&"
import script from "./PageNester.vue?vue&type=script&lang=ts&"
export * from "./PageNester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports